module.exports = function (fox) {
	var FormElementBase = require('./base')(fox);
	var ArrayProto = Array.prototype;

	return fox.extend({
		__constructor: function () {
			this.super('__constructor', arguments);

			this.formLayer.handleEvent('@this', 'input_' + this.key, function (params) {
				return this.formLayer.dispatchEvent('input', fox.merge({field: this.key}, params));
			}.bind(this));
		},

		registerEventCallbacks: function () {
			this.super('registerEventCallbacks', arguments);

			if (!fox.inArray(['radio', 'checkbox'], this.inputType)) {
				this.formLayer.addDomHandler({
					event: 'input',
					target: this.nodes[0],
					callback: function () {
						this.dispatchEvent('input', {value: this.getValue()});
					}.bind(this)
				});
			}

			if (this.inputType === 'submit') {
				this.formLayer.addDomHandler({
					event: 'click',
					target: this.nodes[0],
					callback: function () {
						this.submitIsPressed = true;
					}.bind(this)
				});

				this.formLayer.handleEvent('@this', 'submit', function () {
					delete this.submitIsPressed;
				}.bind(this), {
					prefix: 'sendTypeSubmitValue'
				})
			}
		},

		init: function () {
			var initResult = this.super('init', arguments);

			this.inputType = this.nodes[0].type;

			this.registerEventCallbacks();

			if (ArrayProto.some.call(this.nodes, function (node) {return node.name.match(/\w+\[\]$/) !== null;})) {
				this.valueAsArray = true;
			} else {
				this.delimiter = this.params.delimiter || ',';
			}

			return initResult;
		},

		getValue: function () {
			if (!this.inDom()) return this.super('getValue', arguments);

			switch (this.inputType) {
				case 'checkbox':
				case 'radio':
					var values = ArrayProto.reduce.call(this.nodes, function (acc, node) {
						if (node.checked) acc.push(node.value);

						return acc;
					}, []);

					if (this.valueAsArray) {
						this.value = values;
					} else {
						this.value = values.join(this.delimiter);
					}
				break;
				case 'submit':
					if (!this.submitIsPressed) {
						this.value = '';
					} else {
						this.value = this.nodes[0].value;
					}
				break;
				default:
					this.value = this.nodes[0].value;
			}

			return this.super('getValue', arguments);
		},

		setValue: function (value) {
			if (!this.inDom()) return this.super('setValue', arguments);

			var processed = true;

			switch (this.inputType) {
				case 'checkbox':
					if (!fox.isArray(value)) {
						if (fox.isString(value)) {
							value = value.split(this.delimiter);
						} else {
							value = [];
						}
					}

					ArrayProto.some.call(this.nodes, function (node) {
						node.checked = fox.inArray(value, node.value);
					});
				break;
				case 'radio':
					processed = ArrayProto.some.call(this.nodes, function (node) {
						return node.value === value && (node.checked = true);
					});
				break;
				case 'submit':
					value = this.nodes[0].value;
				break;
				default:
					this.nodes[0].value = value;
			}

			return processed && this.super('setValue', arguments) || this;
		},

		reset: function () {
			this.value = '';

			switch (this.inputType) {
				case 'checkbox':
				case 'radio':
					this.nodes.forEach(function (node) {
						node.checked = false;
					});
				break;
				case 'submit':
					this.value = this.nodes[0].value;
				break;
				default:
					this.nodes[0].value = this.value;
			}

			return this.super('reset', arguments);
		}
	}, FormElementBase, null, 'FormElementDomInput');
}


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/elements/dom/input.js
// module id = 42
// module chunks = 0